import React, { useRef, useEffect } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { Layout } from '@components';
import { Carousel } from 'react-responsive-carousel'; // Import your carousel library here
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Ensure styles are imported
import Image1 from '@images/alphabit/1.png';
import Image2 from '@images/alphabit/2.png';
import Image3 from '@images/alphabit/3.png';
import Image4 from '@images/alphabit/4.png';
import Image5 from '@images/alphabit/5.png';

import { usePrefersReducedMotion } from '@hooks';

const StyledPageContainer = styled.div`
  margin: 0 auto;
  max-width: 1400px; /* Set maximum width for the entire page */

  .project-tech-list {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    z-index: 2;
    margin: 25px 0 10px;
    padding: 0;
    list-style: none;

    li {
      margin: 0 20px 5px 0;
      color: var(--light-slate);
      font-family: var(--font-mono);
      font-size: var(--fz-xs);
      white-space: nowrap;
    }

    @media (max-width: 768px) {
      margin: 10px 0;

      li {
        margin: 0 10px 5px 0;
        color: var(--lightest-slate);
      }
    }
  }

  img {
    border-radius: var(--border-radius);
  }
  ul.skills-list {
    display: column;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-sans);
      font-size: var(--fz-xl);
      @media (max-width: 768px) {
        font-size: var(--fz-lg);
      }

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 24px;

        @media (max-width: 768px) {
          line-height: 20px;
        }
      }
    }
  }
`;

const StyledCarouselContainer = styled.div`
  margin: 50px auto; /* Adjust margin as needed */
`;

const CarematePage = ({ location, data }) => {
  const revealTitle = useRef(null);
  const revealCarousel = useRef(null);
  const revealPara = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealTitle.current, srConfig());
    sr.reveal(revealPara.current, srConfig(200, 0));
    sr.reveal(revealCarousel.current, srConfig(400, 0));
  }, []);

  const tech = ['Next.Js', 'Figma', 'Photoshop'];

  const skills = [
    'Authentication & profile management microservice',
    'Search & filtering microservice',
    'Communication microservice',
    'Booking microservice',
    'Notification microservice',
  ];

  return (
    <Layout location={location}>
      <Helmet title="Caremate" />

      <StyledPageContainer>
        <main>
          <header>
            <h1 className="big-heading" ref={revealTitle}>
              Détails du projet
            </h1>
            <div ref={revealPara}>
              <p className="subtitle">Le club Alphabit</p>
              <p>
                Alphabit est un club d’étudiants de mon école d’ingénieur en informatique, qui font
                vivre et partagent leur intérêt pour l’informatique et les sciences du numérique.
                Les membres se réunissent régulièrement pour décider des activités : formations et
                conseils, mais aussi événements culturels et de détente. Le club a organisé de
                nombreux événements au fil des ans, parmi lesquels Tech Stars StartUp Weekend,
                Coding Challenge, DevDay, Gaming Tournament, Hash Code ou encore Project Guide.
              </p>
              <p className="subtitle">Le site Alphabit</p>
              <p>
                Le site Alphabit a été conçu et développé pour présenter le club : ses partenaires,
                ses produits, ses objectifs et ses grands événements. L’idée est de donner envie aux
                étudiants de le rejoindre et de collaborer avec lui. Sur ce projet, j’ai réalisé le
                design UI/UX du site, et j’ai fait évoluer le front-end avec Next.js pour
                l’améliorer.
              </p>

              <p>
                Découvrez le site du club Alphabit en ligne.{' '}
                <a href="https://www.alphabit.club/" target="_blank" rel="noreferrer">
                  Site Alphabit
                </a>
              </p>
            </div>
          </header>

          <StyledCarouselContainer ref={revealCarousel}>
            <Carousel
              showArrows={false}
              showStatus={false}
              showThumbs={false}
              autoPlay
              interval={3000}
              infiniteLoop>
              <div>
                <img src={Image1} alt="Image 2" />
              </div>
              <div>
                <img src={Image2} alt="Image 1" />
              </div>
              <div>
                <img src={Image3} alt="Image 3" />
              </div>
              <div>
                <img src={Image4} alt="Image 4" />
              </div>
              <div>
                <img src={Image5} alt="Image 5" />
              </div>
            </Carousel>
          </StyledCarouselContainer>
          <p className="subtitle">Technologies utilisées</p>
          {tech.length && (
            <ul className="project-tech-list">
              {tech.map((tech, i) => (
                <li key={i}>{tech}</li>
              ))}
            </ul>
          )}
        </main>
      </StyledPageContainer>
    </Layout>
  );
};

CarematePage.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default CarematePage;
